import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment, useContext, useState } from 'react'
import moment from 'moment';
import { Card, CardBody, CardFooter, Col, DropdownItem, DropdownMenu, DropdownToggle, Media, Row, UncontrolledDropdown } from 'reactstrap';
import { findMyPaysAsProperty } from '../../helpers/api/finance';
import useSWRFetchPagination from '../../helpers/hooks/useSWRFetchPagination';
import FalconCardHeader from '../common/FalconCardHeader';
import Loader from '../common/Loader';
import Calendar from '../common/Calendar';
import PageHeader from '../common/PageHeader';
import { Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import FullPagination from '../common/pagination/FullPagination';
import withRedirect from '../../helpers/hoc/withRedirect';
import Filter from '../common/Filter';
import SupportLink from '../root/support/components/SupportLink';
import { CurrencyContext } from '../../context/Context';

const PropertyPays = () => {

    const formatDateSafe = (date) => {
        if (!date) return 'N/D';

        const raw = String(date).trim();
        if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
            const [year, month, day] = raw.split('-');
            return `${year}-${month}-${day}`;
        }

        const parsed = moment(raw);
        return parsed.isValid() ? parsed.format('YYYY-MM-DD') : 'N/D';
    };

    const { baseCurrency } = useContext(CurrencyContext);
    const [params, setParams] = useState({ state: 0, start_date: null, end_date: null })

    const filter_options = [
        { value: 0, displayName: 'No pagadas', disabled: false },
        { value: 1, displayName: 'Pagadas', disabled: false },
    ];

    const {
        data,
        isLoading,
        meta,
        handler: { goToPage, nextPage, perPage, previousPage }
    } = useSWRFetchPagination(findMyPaysAsProperty, params);

    const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];


    return (
        <Fragment>
            <PageHeader
                title="Mis pagos" titleTag="h2"
                description={'Visualiza tus pagos en el condominio.'}
                className="mb-3" col={{ lg: 9 }}
            >
                <SupportLink />
            </PageHeader>

            <Card>
                <FalconCardHeader title='Pagos realizados'>
                    <Row>
                        <Col xs={12}>
                            < Filter
                                keyField='state'
                                options={filter_options}
                                selectType={setParams}
                                dateFilter={true}
                            />
                        </Col>
                    </Row>
                </FalconCardHeader>
                {!isLoading ? <>
                    <CardBody className='pt-0'>
                        {data.map((payment, i) => {

                            const date = new Date(payment.created_at);
                            const paymentDate = formatDateSafe(payment.payment_date);
                            const paidAmountConverted = Number(payment?.amount_converted ?? payment?.paid_amount_converted);
                            const convertedCurrencyIso = payment?.exchange_rate?.currency?.iso;

                            return (
                                <Row key={i} className={payment?.status === 'pending' ? 'border-top py-3' : payment?.status === 'canceled' ? 'alert-warning border-top py-3' : payment?.status === 'refused' ? 'alert-danger border-top py-3' : payment?.status === 'voided' ? 'alert-secondary border-top py-3' : 'alert-success border-top py-3'}>
                                    <Col xs='auto' className='d-flex align-items-center'>
                                        <Media>
                                            <Calendar month={months[date.getMonth()]} day={date.getDate()} />
                                            <Media body className="position-relative pl-3 align-self-center">
                                                <p className='mb-0'><Link to={`/dashboard/my/finance/pays/${payment?.id}`}>Pago mensual</Link></p>
                                                <p className='fs--1 mb-0 font-weight-bolder'>{payment?.status === 'pending' ? 'Pendiente' : payment?.status === 'canceled' ? 'Cancelado por ti' : payment.status === 'refused' ? 'Pago rechazado' : payment.status === 'voided' ? 'Anulado' : 'Aprobado'}</p>
                                                {payment?.control_number && <p className='fs--1 mb-0 text-600'>N° de control {payment.control_number}</p>}
                                            </Media>
                                        </Media>
                                    </Col>
                                    <Col xs={2} className='d-flex align-items-center justify-content-end'>
                                        <Media>
                                            <Media body className="border-left position-relative pl-3">
                                                <p className='mb-0 font-weight-bolder'>Fecha de pago</p>
                                                <p className="fs--1 mb-0 text-600">
                                                    {paymentDate}
                                                </p>
                                            </Media>
                                        </Media>
                                    </Col>
                                    <Col xs={3} className='d-flex align-items-center justify-content-end'>
                                        <Media>
                                            <Media body className="border-left position-relative pl-3">
                                                <p className='mb-0 font-weight-bolder'>Monto</p>
                                                <p className="fs--1 mb-0 text-600">
                                                    <NumberFormat displayType='text' value={payment?.amount} thousandSeparator decimalScale={2} fixedDecimalScale prefix={`${baseCurrency.symbol} `} />
                                                </p>
                                                {Number.isFinite(paidAmountConverted) && convertedCurrencyIso && (
                                                    <p className="fs--1 mb-0 text-600 mt-1">
                                                        <NumberFormat
                                                            displayType='text'
                                                            value={paidAmountConverted}
                                                            thousandSeparator
                                                            decimalScale={2}
                                                            fixedDecimalScale
                                                            prefix={`${convertedCurrencyIso} `}
                                                        />
                                                    </p>
                                                )}
                                            </Media>
                                        </Media>
                                    </Col>
                                    <Col className="d-sm-flex align-items-center justify-content-end">
                                        <UncontrolledDropdown direction="left" className="d-inline-block ml-2">
                                            <DropdownToggle color="falcon-default" size="sm">
                                                <FontAwesomeIcon icon="ellipsis-h" />
                                            </DropdownToggle>
                                            <DropdownMenu right>
                                                <Link to={`/dashboard/my/finance/pays/${payment?.id}`}><DropdownItem >Ver detalles</DropdownItem></Link>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </Col>
                                </Row>
                            )
                        })}
                    </CardBody>
                    <CardFooter>
                        <FullPagination
                            nextPage={nextPage}
                            prevPage={previousPage}
                            goToPage={goToPage}
                            meta={meta}
                            className={'shadow-none'}
                            posText={"pagos"}
                            perPage={perPage} />
                    </CardFooter>
                </> : <Loader padding='py-5' />}
            </Card>
        </Fragment>
    )
}

export default withRedirect(PropertyPays);